module.exports = __webpack_public_path__ + "static/img/about-03.7f60a21.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/about-03.png
// module id = iCzN
// module chunks = 0